<template>
  <div class="container mb-4">
    <vue-headful
      :title="
        `${categorys[this.$route.params.catId]} - Thong Firearms ร้านปืนธง`
      "
      :keywords="
        `${categorys[this.$route.params.catId]}, Thong Firearms, ปืนธง`
      "
      image="https://thongarms.com/dist/logo.png"
      lang="th"
    />
    <h1 class="mt-4 mb-4">{{ categorys[this.$route.params.catId] }}</h1>
    <!-- <table class="table table-striped">
      <thead>
        <tr>
          <th>Name</th>
          <th>Detail</th>
          <th>Brand</th>
          <th>Category</th>
          <th colspan="2">Action</th>
        </tr>
      </thead>
      <tbody>
          <tr v-for="arm of arms" :key="arm['.key']">
            <td>{{ arm.name }}</td>
            <td>{{ arm.detail }}</td>
            <td>{{ arm.brand }}</td>
            <td>{{ arm.category }}</td>
            <td>
                <router-link :to="{ name: 'Edit', params: {id: arm['.key']} }" class="btn btn-warning">
                    Edit
                </router-link>
            </td>
          </tr>
      </tbody>
    </table>-->
    <div class="grid-container">
      <div class="spinner-grow text-danger" role="status" v-if="!arms.length">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="row w-100">
        <div
          v-for="arm in activeArms"
          :key="arm.id"
          class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3 mb-sm-4 wow fadeIn"
        >
          <div class="item">
            <div class="img-product max-width d-flex align-items-center">
              <img
                v-bind:src="'/src/assets/product/' + arm.img"
                :alt="`ปืนร้านปืนธง ${arm.name}`"
                :title="arm.name"
              />
            </div>

            <div id="product-detail" class="mt-3">
              <h5 :title="arm.name">{{ arm.name }}</h5>
              <b-overlay
                :show="arm.inStock == 0"
                class="d-inline-block width-100"
                bg-color="white"
                opacity="0.8"
                blur="10px"
              >
                <p class="color-70">{{ arm.detail | snippet }}</p>
                <template v-slot:overlay>
                  <div class="text-center">
                    <h6 class="text-danger">OUT OF STOCK</h6>
                  </div>
                </template>
              </b-overlay>
            </div>

            <div id="read-more" class="text-center">
              <router-link v-bind:to="/product/ + arm.id" class="btn"
                >รายละเอียด</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../config_db";
export default {
  components: {
    name: "Category"
  },
  firebase() {
    //console.log("Param ID: "+this.$route.params.catId)
    return {
      arms: db
        .ref("product")
        .orderByChild("category")
        .equalTo(Number.parseInt(this.$route.params.catId))
    };
  },
  data() {
    return {
      arms: [],
      categorys: ["", "ปืนสั้น", "ปืนยาว"]
    };
  },
  computed: {
    activeArms() {
      let result = this.arms.filter(function(u) {
        return u.show != false && u.show !== "FALSE";
      });

      return result.sort((a, b) => (a.brand > b.brand ? 1 : -1));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/component/Category.vue